import React from 'react';

import DOMPurify from 'dompurify';
import { marked } from 'marked';

import { Box, BoxProps } from '@mui/material';

type Props = {
  content: string;
  boxProps?: BoxProps;
};

export default function MarkdownPreview({ content, ...boxProps }: Props) {
  const html = DOMPurify.sanitize(marked.parse(content, { async: false }));
  return <Box dangerouslySetInnerHTML={{ __html: html }} {...boxProps} />;
}
